import React from "react";
import {
  IconSize,
  COLOR_APP_TEXT,
  COLOR_APP_TEXT_LIGHT,
  IconProps,
} from "../theme";

const Checkbox: React.FC<IconProps & { isChecked: boolean }> = ({
  isChecked,
  size = IconSize.XS,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 12 12"
      data-testid="checkbox"
    >
      <circle
        cx="6"
        cy="6"
        r="5.25"
        fill={isChecked ? COLOR_APP_TEXT : "none"}
        stroke={isChecked ? COLOR_APP_TEXT : COLOR_APP_TEXT_LIGHT}
        strokeWidth="1.5"
      />
      {isChecked && (
        <path stroke="#fff" strokeWidth="1" d="M4 6.5L5.5 8L8.5 4.5" />
      )}
    </svg>
  );
};

export default Checkbox;
